"use client";

import { Toaster as SonnerToaster, type ToasterProps } from "sonner";

export function Toaster({ position = "bottom-right" }: { position?: ToasterProps["position"] } = {}) {
	return (
		<SonnerToaster
			position={position}
			richColors
			closeButton
			theme="light"
			toastOptions={{
				classNames: {
					toast: "border-border bg-card text-foreground shadow-lift",
				},
			}}
		/>
	);
}
